module.exports = __webpack_public_path__ + "img/av245.28fc6ab1.png";